import { render, staticRenderFns } from "./c-SNPMB-Kategori.vue?vue&type=template&id=874013b6&scoped=true&"
import script from "./c-SNPMB-Kategori.vue?vue&type=script&lang=js&"
export * from "./c-SNPMB-Kategori.vue?vue&type=script&lang=js&"
import style0 from "./c-SNPMB-Kategori.vue?vue&type=style&index=0&id=874013b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874013b6",
  null
  
)

export default component.exports